<template>
  <div class="content c895">
    <h2>Pretočni grelnik vode 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev9" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Pretočni grelnik vode</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev9&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Pretočni grelnik vode</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev9&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="PGV">Pretočni grelnik vode</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            1.912 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">144 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Pretočni grelnik vode</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a class="actionBtnMore active" style="cursor:pointer;">Prhajmo se, namesto da se kopamo</a>

          <div style class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Če se prhamo namesto kopamo, lahko za to opravilo prihranimo 75 % električne energije, saj pri prhanju porabimo 4-krat manj vode in energije, kot pri kopanju v kadi.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Preverimo tesnjenje vodovodnih pip</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Preverimo, če vodovodne pipe dobro tesnijo. Če ne tesnijo dobro, steče iz pipe na minuto 10 kapljic vode, ki je segreta na 60 °C, kar znese 170 litrov vode na mesec. Prihranimo lahko okoli 12 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Grelnik vode vklopimo le v času manjše tarife</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če grejemo vodo le
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov#tarife"
                  target="_blank"
                >v času nižje tarife</a>, lahko v primerjavi z gretjem vode le v času višje tarife (VT) prihranimo na stroških porabljene energije, ki jo porabi samo grelnik vode (bojler), okoli 30 %. Vodo ogrejemo do 60 °C. Pri tej temperaturi je segrevanje vode najbolj ekonomično.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko energije lahko prihranite. Toda za vse električne naprave v gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi različnosti naprav in situacij za te nasvete ni mogoče količinsko opredeliti.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE PRETOČNI GRELNIK VODE 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">144,35 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE PRETOČNI GRELNIK VODE 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000005.png?5deee3c8-5d9a-4f2d-b79f-a2ce4665d87d"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 21, 257, 21, 30, 119, 30, 119, 30, 144, 257, 144"
              title="13.11.2021; 144,3513438276"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 46, 200, 46, 257, 21, 257, 21, 257, 144, 200, 144"
              title="13.11.2025; 721,756719138"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 70, 144, 70, 200, 46, 200, 46, 200, 144, 144, 144"
              title="13.11.2024; 577,4053753104"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 95, 87, 95, 144, 70, 144, 70, 144, 144, 87, 144"
              title="13.11.2023; 433,0540314828"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 119, 30, 119, 87, 95, 87, 95, 87, 144, 30, 144"
              title="13.11.2022; 288,7026876552"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>